import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const TRACK_URL = process.env.NODE_ENV === 'production' ? '/api/track' : 'http://localhost:5000/api/track';
const SESSION_KEY = 'rc_visitor_session';

function getOrCreateSession() {
  let sid = sessionStorage.getItem(SESSION_KEY);
  if (!sid) {
    sid = crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2)}`;
    sessionStorage.setItem(SESSION_KEY, sid);
  }
  return sid;
}

function getUTMParams() {
  const params = new URLSearchParams(window.location.search);
  return {
    utmSource: params.get('utm_source') || '',
    utmMedium: params.get('utm_medium') || '',
    utmCampaign: params.get('utm_campaign') || '',
    utmContent: params.get('utm_content') || '',
    utmTerm: params.get('utm_term') || '',
    gclid: params.get('gclid') || '',
    fbclid: params.get('fbclid') || '',
    ttclid: params.get('ttclid') || '',
    msclkid: params.get('msclkid') || ''
  };
}

// Store UTM params in sessionStorage on first visit (they disappear on SPA navigation)
function persistUTMs() {
  const utms = getUTMParams();
  const hasAny = Object.values(utms).some(v => v);
  if (hasAny) {
    sessionStorage.setItem('rc_utms', JSON.stringify(utms));
  }
  // Return persisted UTMs (from first visit or current)
  try {
    const saved = sessionStorage.getItem('rc_utms');
    return saved ? JSON.parse(saved) : utms;
  } catch {
    return utms;
  }
}

export function getVisitorSessionId() {
  return sessionStorage.getItem(SESSION_KEY) || '';
}

export default function useVisitorTracking() {
  const location = useLocation();

  useEffect(() => {
    const trackVisit = async () => {
      try {
        const sessionId = getOrCreateSession();
        const utms = persistUTMs();

        await fetch(`${TRACK_URL}/visit`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            page: location.pathname,
            referrer: document.referrer,
            sessionId,
            ...utms
          })
        });
      } catch {
        // Tracking is non-critical, silently fail
      }
    };

    trackVisit();
  }, [location.pathname]);
}

// Call this after login/signup to link the session to the user
export async function linkVisitorSession() {
  try {
    const sessionId = sessionStorage.getItem(SESSION_KEY);
    if (!sessionId) return;
    const token = localStorage.getItem('rg_token');
    if (!token) return;

    await fetch(`${TRACK_URL}/link-user`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify({ sessionId })
    });
  } catch {
    // Non-critical
  }
}
